import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ComponentBase, T4TurboOrderService, OrderCustomerModel } from 't4core';
import { AddStakehholderDialog } from '../../dialogs/AddStakeholder/AddStakeholder';
import { StakeholderModel } from '../../../../../projects/t4core/src/public-api';
import moment from 'moment';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
  selector: 't4order-StakeholderSettings',
  templateUrl: './StakeholderSettings.html',
  styleUrls: ['./StakeholderSettings.css']
})
export class StakeholderSettings extends ComponentBase {

  constructor(el: ElementRef, private orderSvc: T4TurboOrderService, private fb: FormBuilder) {
        super();

  }

  @ViewChild("tblStakeholder", { static: false }) tblStakeholders: T4DatatableWidget;
  @ViewChild("tblStakeholderCustomers", { static: false }) tblStakeholdersCustomers: T4DatatableWidget;
  @Input() public customerId: number;

  public stakeholderData: StakeholderModel[];
  public customerData: StakeholderModel[];

  public selectedCustomer: OrderCustomerModel;
  public inputPercentile: number = 0;

  public edit: boolean = false;

  public inputValue: string = "";

  async ngOnInit() {
    await this.loadData();
  }

  public async loadData() {
    this.customerData = await this.orderSvc.GetStakeholderCustomerRelations(this.customerId);
    this.stakeholderData = await this.orderSvc.GetCustomerStakeolderRelations(this.customerId);
  }

  public async add() {
    var customer = await this.Dialog.open(AddStakehholderDialog, {
      width: '500px',
      data: { customerId: this.customerId }
    }).afterClosed().toPromise();

    if (customer) {
      this.selectedCustomer = customer;
      this.inputValue = this.selectedCustomer.DeliveryAddressCustomerName;
      this.inputPercentile = 0;

      if (this.customerData.some(x => x.CustomerId === customer.Id)) {
        this.edit = true;
      } else {
        this.edit = false;
      }

    }
  }

  public async clear() {
    this.edit = false;
    this.selectedCustomer = null;
    this.inputPercentile = 0;
    this.inputValue = "";
  }

  public async editRow(row: StakeholderModel) {
    this.selectedCustomer = row.Customer;
    this.inputPercentile = row.Percentile;
    this.inputValue = row.Customer.DeliveryAddressCustomerName;
    this.edit = true;
  }

  public async saveRow() {
    var result = await this.orderSvc.SaveStakeholderRelation(this.customerId, this.selectedCustomer.Id, this.inputPercentile);
    if (result != null) {
      const existingIndex = this.customerData.findIndex(item => item.Id === result.Id);

      if (existingIndex !== -1) {
        // If found, replace the existing item
        this.customerData[existingIndex] = result;
        this.UI.snackBar("Updated " + result.DeliveryAddressCustomerName);
      } else {
        this.customerData.push(result);
        this.UI.snackBar("Added stakeholder")
      }

      this.selectedCustomer = null;
      this.inputValue = "";
      this.inputPercentile = null;

      this.tblStakeholdersCustomers.update();
    } else {
      this.UI.snackBar("Error have occured.")
    }
  }

  public async deleteRelation(row: StakeholderModel) {
    if (!row) return false;

    var x = await this.UI.confirm("Turbo.Order.StakeholderSettings.headConfirmDelete", "Are you sure?", "Turbo.Order.StakeholderSettings.msgConfirmDelete", 'Are you sure that you want to delete this?',);
    if (x) {

    var result = await this.orderSvc.DeleteStakeholderRelation(this.customerId, row.Customer.Id);
    if (result) {
      // Find the index of the row and remove it
      const index = this.stakeholderData.findIndex(item => item.Id === row.Id);
      if (index !== -1) {
        this.stakeholderData.splice(index, 1); 
      }

      this.UI.snackBar("Removed stakeholder relation");
      this.tblStakeholdersCustomers.update();
      }
    }
  }
}
